import { getAllSacredEntries, beginnerSummary, displayName } from "./registry";
import { normalizeSearchText, searchBlobForEntry } from "./search-normalize";

/**
 * Client-side sacred library search (mirrors GET /library/search shape).
 * @param {string} query
 * @param {number} [limit=24]
 */
export function searchSacredLibrary(query, limit = 24) {
  const q = normalizeSearchText(query);
  if (!q) return [];

  const hits = [];
  for (const { type, entry } of getAllSacredEntries()) {
    const blob = searchBlobForEntry(type, entry);
    if (blob.includes(q) || q.split(" ").every((tok) => tok.length > 1 && blob.includes(tok))) {
      hits.push({
        id: entry.id,
        type,
        name: displayName(type, entry),
        summary: beginnerSummary(type, entry),
        image_url: entry.image_url ?? null,
      });
    }
  }

  hits.sort((a, b) => {
    const aNorm = normalizeSearchText(a.name);
    const bNorm = normalizeSearchText(b.name);
    const a0 = aNorm.startsWith(q) || a.id === q.replace(/\s/g, "_") ? 0 : 1;
    const b0 = bNorm.startsWith(q) || b.id === q.replace(/\s/g, "_") ? 0 : 1;
    if (a0 !== b0) return a0 - b0;
    return a.name.localeCompare(b.name);
  });

  return hits.slice(0, limit);
}
